import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
var Banner = function Banner(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    toShowCloseIcon = _ref.toShowCloseIcon,
    primaryBtn = _ref.primaryBtn,
    heading = _ref.heading,
    subCopy = _ref.subCopy,
    secondaryBtn = _ref.secondaryBtn,
    toClose = _ref.toClose,
    toShow = _ref.toShow;
  var _useState = useState(toShow),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  useEffect(function () {
    setVisible(toShow);
  }, [toShow]);
  var close = function close() {
    setVisible(false);
    if (toClose) {
      toClose();
    }
  };
  var setPrimaryOp = function setPrimaryOp(button, ifPrimaryButton) {
    if (button.dataOp !== '') {
      var value = ifPrimaryButton ? 'SLD' : 'SL2';
      if (ifPrimaryButton && secondaryBtn) {
        value = 'SL1';
      }
      if (button.dataOp) {
        value = button.dataOp;
      }
      return {
        'data-op': value
      };
    }
    return {};
  };
  var returnCTA = function returnCTA(button, ifPrimaryButton) {
    var setClassName = function setClassName() {
      if (ifPrimaryButton) {
        if (subCopy || secondaryBtn) {
          return "btn-primary w-100 w-sm-auto ".concat(secondaryBtn ? 'ms-3' : 'btn-min-width');
        }
        return "btn-primary w-sm-auto w-100 btn-min-width";
      } else {
        return "btn-tertiary flex-shrink-0";
      }
    };
    var CustomTag = button.link ? 'a' : 'button';
    return React.createElement(CustomTag, _objectSpread(_objectSpread(_objectSpread({
      className: "btn text-nowrap ".concat(setClassName())
    }, button.link ? {
      href: button.link
    } : {}), setPrimaryOp(button, ifPrimaryButton)), button.attributes || {}), parse(button.text));
  };
  return React.createElement("div", {
    className: "".concat(className, " position-fixed sticky-banner bg-white border p-3 pb-md-3 d-md-flex ").concat(visible ? 'toShow' : '')
  }, React.createElement("div", {
    className: "".concat(secondaryBtn ? '' : 'text-center text-md-start', " d-md-flex justify-content-md-between flex-md-grow-1 align-items-center")
  }, React.createElement("p", {
    className: "mb-md-0 fw-bold body-text-sm text-center text-md-start flex-grow-md-0 ".concat(toShowCloseIcon ? 'pe-5' : 'pe-md-5')
  }, parse(heading)), subCopy || secondaryBtn ? React.createElement("div", {
    className: "".concat(subCopy ? 'text-center' : 'd-flex justify-content-sm-center')
  }, secondaryBtn && subCopy ? React.createElement("div", {
    className: "d-flex justify-content-sm-center"
  }, returnCTA(secondaryBtn, false), returnCTA(primaryBtn, true)) : secondaryBtn && !subCopy ? React.createElement(React.Fragment, null, returnCTA(secondaryBtn, false), returnCTA(primaryBtn, true)) : returnCTA(primaryBtn, true), subCopy ? React.createElement("p", {
    className: "mb-0 lh-1 mt-2 text-gray"
  }, React.createElement("small", null, parse(subCopy))) : null) : returnCTA(primaryBtn, true)), toShowCloseIcon && React.createElement("button", {
    type: "button",
    className: "close btn-reset ps-md-3",
    "aria-label": "Close",
    "data-link-both": "sld-close",
    onClick: close
  }, React.createElement("span", {
    "aria-hidden": "true",
    className: "ecs-font-icon-act-close"
  })));
};
export default Banner;